import React, { Fragment } from 'react';
import { I18n } from '@td/shared_utils';
import PropTypes from 'prop-types';

import MedicationAutocomplete from './medication-autocomplete';
import useQueryParams from '../../lib/hooks/useQueryParams';
import { Medication } from '../types/medication';

const MedicationFormulariesHeader = ({ redirectOnClear }) => {
  const { search_term: searchTerm } = useQueryParams();

  return (
    <Fragment>
      <a href="/medication_formularies">
        <I18n scope="medication_formularies" text="title" />
      </a>
      <h1 className="page-heading">
        <I18n scope="medication_formularies" text="title" />
      </h1>
      <MedicationAutocomplete initialValue={searchTerm} redirectOnClear={redirectOnClear} />
    </Fragment>
  );
};

MedicationFormulariesHeader.propTypes = {
  redirectOnClear: PropTypes.bool
};

MedicationFormulariesHeader.defaultProps = {
  redirectOnClear: false
};

export default MedicationFormulariesHeader;
